@if(patient){
<div tuiCardLarge tuiSurface="elevated">

    <div class="row">
        <h2>Matériel</h2>
    </div>

    <div class="row">
        <div class="col col-12 col-md-6">
            @for (materiel of materielVenduList; track $index) {
            <app-materiel-data [materiel]="materiel" />
            }
        </div>
        <div class="col col-12 col-md-6">
            @for (materiel of patient.tableauDeBord?.materielEnlocationList; track $index) {
            @if (!activite || materiel.activite == activite) {
            <app-materiel-data [materiel]="materiel" />
            }
            }
        </div>

        @if (!(patient.tableauDeBord?.materielVenduList) && !(patient.tableauDeBord?.materielEnlocationList)) {
        <div class="col col-12">
            <article>Pas de matériel.</article>
        </div>
        }

    </div>

</div>
}@else{
<div tuiCardLarge tuiSurface="elevated">

    <div class="row">
        <h2>Matériel</h2>
    </div>

    <div class="row">
        <div class="col col-12 col-md-6">
            <app-materiel-data />
        </div>
        <div class="col col-12 col-md-6">
            <app-materiel-data />
            <app-materiel-data />
        </div>

    </div>

</div>
}